




































import { MaterieelVerkoopType } from "@/services/api-client-generated";
import { getTranslationMixin } from "@/mixins/getTranslationMixin";
import { detectUriTextMixin } from "@/mixins/detectUriTextMixin";

export default {
  name: "DetailsInformation",
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  mixins: [getTranslationMixin, detectUriTextMixin],
  data() {
    return {
      MaterieelVerkoopType
    };
  },
  computed: {
    hasLocation() {
      return this.$store.getters.selectedLocationId !== null;
    },
    showPriceOnNoLocation() {
      return this.$store.getters.getBoolSetting("ToonPrijsMaterieellocatie");
    }
  },
  methods: {
    retrieveImageUrl(imageUrl) {
      var url = "";
      try {
        url = require(`../../assets/_default/images/safety/${imageUrl}.jpg`);
      } catch (e) {
        console.log(`Image not found: ${imageUrl}.jpg`);
      }

      return url;
    }
  }
};
